import { func, array, bool, any, number, string, object } from 'prop-types';
import React, { useEffect, useState } from 'react';
import Icon from '@sabre/spark-react-core/icon';
import { Popover } from 'react-tiny-popover';
import {
    Column,
    Table
} from 'react-virtualized';
import 'react-virtualized/styles.css';
import Tooltip from '@sabre/spark-react-core/tooltip';
import TextInput from '@sabre/spark-react-core/text-input';
import Checkbox from '@sabre/spark-react-core/checkbox';
import Button from '@sabre/spark-react-core/button';
import {
    CRITERIA_HEADER_DETAILS

} from '../../../utils/constants.js';
import {
    useWindowSize,
    useWindowWidth,
    useWindowHeight,
} from '@react-hook/window-size';
const TableView = ({
    rowData,
    reference,
    isLeftSideLayoutOpen,
    isScroll,
    isMultiFilter,
    isToolTipShow,
    handleScrolling,
    getSelectedIndex,
    selectedRowDetails,
    getSelectedCellIndex,
    selectedCellIndexValue,
    headerData,
    handleSorting,
    handleFilterChange,
    handleFilterUniqueItems,
    handleClearEvent,
    totalItem,
    fullData,
    isStopAPI,
    hostCarrier,
    title,
    isFetchDataCompleted

}) => {
    // const [selectedIndex, setSelectedIndex] = useState(-11);
    // const [selectedCellIndex, setSelectedCellIndex] = useState(-11);
    const [selectedRecordConfig, setSelectedRecordConfig] = useState({
        selectedRowIndex: [0],
        selectedCellIndex: 0,
        selectedCellTableType: isScroll ? 'secondary_table' : 'primary_table',
        currentRow: 1
    });
    const [titleConfig, setTitleConfig] = useState([]);
    const [tableHeaderData, setTableHeaderData] = useState(headerData);
    const [selectedConfig, setSelectedConfig] = useState({
        selectedColumnKey: ''
    });
    const [popUpOpenCloseConfig, setPopUpOpenCloseConfig] = useState({
        rowDetails: {}
    });
    const [tableWidth, setTableWidth] = useState(0);
    const [width, height] = useWindowSize()
    const [tableHeight, setTableHeight] = useState(height);
    useEffect(() => {
        const divElement = document.querySelector(".parent-table-component-height");
        const elemHeight = divElement.offsetHeight;
        // const currentHeight = height === 551 ? 500 : height === 571 ? 525 : height === 519 ? 460 : height === 606 ? 570 : height === 635 ? 600 : height === 673 ? 650 : height === 714 ? 700 : height === 808 ? 820 : height === 857 ? 875 : height === 909 ? 940 : height === 1142 ? 1220 : height === 762 ? 752 : height;
        setTableHeight(elemHeight);
    }, [height])

    const handleColumnClick = (data) => {
        setSelectedConfig({
            ...selectedConfig,
            selectedColumnKey: data.dataKey
        })
    }
    const handleRowStyle = (row) => {
        if (selectedRecordConfig.selectedRowIndex && selectedRecordConfig.selectedRowIndex.length > 0 && selectedRecordConfig.selectedRowIndex.includes(row.index))
            return {
                backgroundColor: rowData[row.index].cxr !== hostCarrier ? '#3399cc' : 'gray',
                color: '#fff',
                cursor: 'pointer'
            }
        else {
            return {
                backgroundColor: row.index !== -1 && (rowData[row.index].cxr !== hostCarrier ? '#bceaf8' : 'white'),
                color: row.index !== -1 && (rowData[row.index].cxr !== hostCarrier ? 'black' : 'black'),
                cursor: 'pointer'
            }
        }
    };
    useEffect(() => {
        setSelectedRecordConfig({
            ...selectedRecordConfig,
            selectedRowIndex: [...new Set(selectedRowDetails.selectedRowIndex)],
            selectedCellTableType: selectedRowDetails.selectedCellTableType,
            selectedCellIndex: (selectedRowDetails.selectedCellTableType === 'secondary_table' && isScroll) ? selectedRowDetails.selectedCellIndex : (selectedRowDetails.selectedCellTableType === 'primary_table' && !isScroll ? selectedRowDetails.selectedCellIndex : -11),
            currentRow: selectedRowDetails.currentRow
        });
    }, [selectedRowDetails]);

    const calculateWidth = (width) => {
        switch (width) {
            case 2:
                width = 35;
                break;
            case 3:
                width = 45;
                break;
            case 4:
                width = 55;
                break;
            case 5:
                width = 65;
                break;
            case 6:
                width = 75;
                break;
            case 7:
                width = 85;
                break;
            case 8:
                width = 95;
                break;
            case 9:
                width = 95;
                break;
            case 10:
                width = 105;
                break;
            case 11:
                width = 115;
                break;
            case 12:
                width = 125;
                break;
            case 13:
                width = 135;
                break;
            case 14:
                width = 145;
                break;
            case 15:
                width = 155;
                break;
            case 16:
                width = 165;
                break;
            case 17:
                width = 175;
                break;
            case 18:
                width = 185;
                break;
            case 19:
                width = 195;
                break;
            case 20:
                width = 205;
                break;
            case 21:
                width = 215;
                break;
            case 22:
                width = 225;
                break;
            case 23:
                width = 235;
                break;
            case 23:
                width = 235;
                break;
            case 24:
                width = 245;
                break;
            case 25:
                width = 255;
                break;
            case 26:
                width = 265;
                break;
            case 27:
                width = 275;
                break;
            case 28:
                width = 285;
                break;
            case 29:
                width = 295;
                break;
            case 30:
                width = 305;
                break;
            case 31:
                width = 315;
                break;
            default:
                width = 275;
                break;
        }
        return width;
    }
    const bindingTableTitle = (updatedRecord) => {
        if (isScroll) {
            title.map(list => {
                list.width = 0;
                const filterResult = updatedRecord.filter(subList => list.titleName === subList.groupName);
                filterResult.map(item => list.width = list.width + item.width);
                return list;
            });
        }
        setTitleConfig(title);
    }
    useEffect(() => {
        setSelectedRecordConfig({
            selectedRowIndex: [0],
            selectedCellIndex: 0,
            selectedCellTableType: isScroll ? 'secondary_table' : 'primary_table',
            currentRow: 0
        });
    }, []);
    useEffect(() => {
        if (headerData.length > 0) {
            let totalWidth = 0;
            const updatedRecord = headerData.map((list) => {
                if (list.filterUniqueValues) {
                    const isSelectAll = list.filterUniqueValues.every(subList => subList.value === true);
                    list.isSelectAll = isSelectAll ? true : false
                }
                let uniqueFilter = [];
                rowData.map((newList) => {
                    if ((!newList[list.key] && newList[list.key].toString() !=='0')|| newList[list.key] === '|')
                        uniqueFilter.push('null');
                    else if (newList[list.key] || newList[list.key] === 0)
                        uniqueFilter.push(newList[list.key].toString());

                });
                let uniqueResult = [...new Set(uniqueFilter)];
                list.stringLength = uniqueResult.length > 0 ? Math.max(...(uniqueResult.map(el => el.length))) : 0;
                const sortedData = uniqueResult.sort((a, b) => {
                    if (!parseInt(a))
                        return a.toString().localeCompare(b.toString());
                    else
                        return parseInt(a - b)
                });
                const response = sortedData.map((item) => {
                    return {
                        key: item,
                        value: true
                    };
                });
                if (list.key !== 'yq' && list.key !== 'yr' && list.key !== 'amt' && list.key !== 'sur' && list.key !== 'tax' && list.key !== 'ttl')
                    list.width = calculateWidth(list.stringLength ? list.stringLength > list.key.length ? list.stringLength : list.key.length : list.key.length)
                else
                    list.width = calculateWidth(list.stringLength ? list.stringLength < 8 ? 7 : list.stringLength : list.key.length)
                if ((list.isAscending || list.isDecending) && list.isShowFilterControls && list.key !== 'amt' && list.key !== 'fbc' && list.key !== 'rec dt') {
                    list.width = list.width + 33;
                }
                totalWidth = totalWidth + list.width;
                list.filterUniqueValues = response;
                return list;
            });
            bindingTableTitle(updatedRecord);
            setTableWidth(totalWidth);
            // setSelectedRecordConfig({
            //     selectedRowIndex: [0],
            //     selectedCellIndex: 0,
            //     selectedCellTableType: isScroll ? 'secondary_table' : 'primary_table',
            //     currentRow: 0
            // })
            setTableHeaderData(updatedRecord);
        }
    }, [headerData]);

    const handleCellClick = (event, item, type) => {
        const isRowAvailable = selectedRecordConfig.selectedRowIndex.includes(item.rowIndex);
        if (isRowAvailable && event.ctrlKey) {
            const updatedArray = selectedRecordConfig.selectedRowIndex.filter(list => list !== item.rowIndex);
            const updatedRow = {
                selectedRowIndex: updatedArray,
                selectedCellIndex: item.columnIndex,
                selectedCellTableType: isScroll ? 'secondary_table' : 'primary_table',
                currentRow: updatedArray.length > 0 ? updatedArray[0] : -1
            }
            setSelectedRecordConfig(updatedRow);
            getSelectedIndex(updatedRow);
            return;
        } else if (isRowAvailable && !event.ctrlKey) {
            const updatedRow = {
                selectedRowIndex: [],
                selectedCellIndex: -1,
                selectedCellTableType: isScroll ? 'secondary_table' : 'primary_table',
                currentRow: -1
            }
            setSelectedRecordConfig(updatedRow);
            getSelectedIndex(updatedRow);
            return;
        }
        if (!event.shiftKey || event.ctrlKey) {
            const selectedRows = event.ctrlKey ? selectedRecordConfig.selectedRowIndex && selectedRecordConfig.selectedRowIndex.length > 0 ? [...selectedRecordConfig.selectedRowIndex] : [] : [];
            selectedRows.push(item.rowIndex)
            const updatedRow = {
                selectedRowIndex: selectedRows,
                selectedCellIndex: item.columnIndex,
                selectedCellTableType: isScroll ? 'secondary_table' : 'primary_table',
                currentRow: item.rowIndex
            }
            setSelectedRecordConfig(updatedRow);
            getSelectedIndex(updatedRow);
        } else {
            const updatedArray = [...selectedRecordConfig.selectedRowIndex]
            const startRow = selectedRecordConfig.selectedRowIndex[0] > item.rowIndex ? item.rowIndex : selectedRecordConfig.selectedRowIndex[0];
            const endRow = selectedRecordConfig.selectedRowIndex[0] > item.rowIndex ? selectedRecordConfig.selectedRowIndex[0] : item.rowIndex;
            for (var starting = startRow; starting <= endRow; starting++) {
                updatedArray.push(starting);
            }
            const updatedRow = {
                selectedRowIndex: updatedArray,
                selectedCellIndex: item.columnIndex,
                selectedCellTableType: isScroll ? 'secondary_table' : 'primary_table',
                currentRow: item.rowIndex
            }
            setSelectedRecordConfig(updatedRow);
            getSelectedIndex(updatedRow);

        }
    }
    const handleKeyDown = (event, item) => {
        if (((event.key === 'ArrowUp' && event.keyCode === 38) || (event.key === 'ArrowDown' && event.keyCode === 40)) && !event.shiftKey && !event.ctrlKey) {
            const selectedRows = [];
            selectedRows.push((event.key === 'ArrowUp' && event.keyCode === 38) ? item.rowIndex > 0 && item.rowIndex - 1 : item.rowIndex + 1)
            const updatedRow = {
                selectedRowIndex: selectedRows,
                selectedCellIndex: item.columnIndex,
                selectedCellTableType: isScroll ? 'secondary_table' : 'primary_table',
                currentRow: selectedRows[selectedRows.length - 1]
            }
            setSelectedRecordConfig(updatedRow);
            getSelectedIndex(updatedRow);
            const newRow = `row-details-${(event.key === 'ArrowUp' && event.keyCode === 38) ? item.rowIndex > 0 && item.rowIndex - 1 : item.rowIndex + 1}-${item.columnIndex}`;
            const selectedCell = document.getElementsByClassName(newRow);
            if (selectedCell.length > 0) {
                let selectedTable = 0;
                if (selectedCell.length === 1)
                    selectedTable = 0;
                else
                    selectedTable = isScroll ? 1 : 0
                selectedCell[selectedTable].focus();
            }
        } else if ((event.key === 'ArrowUp' && event.keyCode === 38 && item.rowIndex!==0) || (event.key === 'ArrowDown' && event.keyCode === 40) && event.shiftKey) {
            let selectedRows = (selectedRecordConfig.selectedRowIndex && selectedRecordConfig.selectedRowIndex.length > 0) ? [...selectedRecordConfig.selectedRowIndex] : [];
            var isAscending = selectedRows.slice(1).every((e, i) => e > selectedRows[i]);
            if (selectedRows && selectedRows.length > 0) {
                if (selectedRows.includes(event.key === 'ArrowUp' ? (selectedRows.length > 1 && isAscending) ? item.rowIndex : item.rowIndex - 1 : selectedRows.length >= 1 ? item.rowIndex + 1 : item.rowIndex)) {
                    const index = selectedRows.indexOf(event.key === 'ArrowUp' ? (selectedRows.length > 1 && isAscending) ? item.rowIndex : item.rowIndex - 1 : item.rowIndex);
                    selectedRows.splice(index, 1);
                } else
                    selectedRows.push(event.key === 'ArrowUp' ? item.rowIndex - 1 : item.rowIndex + 1)
            }
            const updatedRow = {
                selectedRowIndex: selectedRows,
                selectedCellIndex: item.columnIndex,
                selectedCellTableType: isScroll ? 'secondary_table' : 'primary_table',
                currentRow: selectedRows[selectedRows.length - 1]
            }
            const newRow = `row-details-${(event.key === 'ArrowUp') ? item.rowIndex > 0 && item.rowIndex - 1 : item.rowIndex + 1}-${item.columnIndex}`;
            const selectedCell = document.getElementsByClassName(newRow);
            if (selectedCell.length > 0) {
                let selectedTable = 0;
                if (selectedCell.length === 1)
                    selectedTable = 0;
                else
                    selectedTable = isScroll ? 1 : 0
                selectedCell[selectedTable].focus();
            }
            setSelectedRecordConfig(updatedRow);
            getSelectedIndex(updatedRow);
        }
        document.getSelection().removeAllRanges();
    };
    const handleDragStart = (event, item, type) => {
        const selectedRows = type === 'end' ? selectedRecordConfig.selectedRowIndex && selectedRecordConfig.selectedRowIndex.length > 0 ? [...selectedRecordConfig.selectedRowIndex] : [] : [];
        selectedRows.push(item.rowIndex)
        const updatedRow = {
            selectedRowIndex: selectedRows,
            selectedCellIndex: item.columnIndex,
            selectedCellTableType: isScroll ? 'secondary_table' : 'primary_table',
            currentRow: selectedRows[selectedRows.length - 1]
        }
        setSelectedRecordConfig(updatedRow);
        getSelectedIndex(updatedRow);
        const newRow = `row-details-${item.rowIndex}-${item.columnIndex}`;
        const selectedCell = document.getElementsByClassName(newRow);
        if (selectedCell.length > 0) {
            let selectedTable = 0;
            if (selectedCell.length === 1)
                selectedTable = 0;
            else
                selectedTable = isScroll ? 1 : 0
            selectedCell[selectedTable].focus();
        }

    }
    const handleDragEnd = (event, item) => {
        event.shiftKey = true;
        handleCellClick(event, item, 'end')
    }
    const cellRenderer = (item) => {
        return <div onClick={(event) => handleCellClick(event, item)} onKeyUp={(event) => handleKeyDown(event, item)} draggable='true' onDragStart={(event) => handleDragStart(event, item)} ond onDragLeave={(event) => handleDragEnd(event, item)}
            tabIndex="0" className={` default-cell row-details-${item.rowIndex}-${item.columnIndex} data-trim table-height spark-pad-l-.5 ${(!isNaN(item.cellData) && item.dataKey !== 'rule' && item.dataKey !== 'ft') ? 'text-align-right spark-pad-r-.5' : 'text-align-left'} ${selectedRecordConfig.selectedRowIndex && selectedRecordConfig.selectedRowIndex.length > 0 && selectedRecordConfig.currentRow === item.rowIndex && selectedRecordConfig.selectedCellIndex === item.columnIndex ? 'tr-selected-cell' : 'tr-un-selected-cell'}`} title={item.cellData}>
            {item.cellData ? item.cellData.toString() : item.cellData}
        </div>
    }
    const handleShowFilter = (rowDetails) => {
        const update = tableHeaderData.map(item => {
            if (item.key === rowDetails.key) {
                item.isFilterOpen = !item.isFilterOpen;
            }
            return item;
        });
        setTableHeaderData(update)
    }
    const handleHideFilter = (rowDetails) => {
        // const update = tableHeaderData.map(item => {
        //     if (item.key === rowDetails.key) {
        //         item.isFilterOpen = false;
        //         item.isShowFilterControls = false;
        //     }
        //     return item;
        // });
        // setTableHeaderData(update)
    }
    const handleEnableControles = (rowDetails) => {
        return tableHeaderData.find(list => list.key === rowDetails.dataKey).filterUniqueValues.length > 0 ? true : false;
    }
    const handleMouseOver = (rowDetails) => {
        if (!handleEnableControles(rowDetails))
            return
        const isFilterOpen = tableHeaderData.some(item => item.isFilterOpen);
        if ((!isStopAPI && parseInt(totalItem) > fullData.length) || isFilterOpen)
            return;
        const update = tableHeaderData.map(item => {
            if (item.key === rowDetails.dataKey && !item.isFilterOpen) {
                if (item.key !== 'yq' && item.key !== 'yr' && item.key !== 'amt' && item.key !== 'sur' && item.key !== 'tax' && item.key !== 'ttl')
                    item.width = calculateWidth(item.stringLength ? item.stringLength > item.key.length ? item.stringLength : item.key.length : item.key.length)
                else
                    item.width = calculateWidth(item.stringLength ? item.stringLength < 8 ? 7 : item.stringLength : item.key.length)
                item.width = (item.key !== 'amt' && item.key !== 'fbc' && item.key !== 'rec dt') ? item.width + 33 : item.width;
                item.isShowFilterControls = true;
            }
            return item;
        });
        bindingTableTitle(update);
        setTableHeaderData(update);
    }
    const handleMouseLeave = (rowDetails) => {
        if (!handleEnableControles(rowDetails))
            return
        const isFilterOpen = tableHeaderData.some(item => item.isFilterOpen);
        if ((!isStopAPI && parseInt(totalItem) > fullData.length) || isFilterOpen)
            return;
        setPopUpOpenCloseConfig({
            rowDetails: rowDetails
        });


        const update = tableHeaderData.map(item => {
            if (item.key === rowDetails.dataKey && item.isShowFilterControls) {
                item.width = (item.key !== 'amt' && item.key !== 'fbc' && item.key !== 'rec dt') ? (!item.isFilterOpen) ? item.width - 30 : item.width : item.width;
                item.isShowFilterControls = item.isFilterOpen ? true : false;
            } else if (item.key === rowDetails.dataKey && !item.isShowFilterControls) {
                item.width = (item.key !== 'amt' && item.key !== 'fbc' && item.key !== 'rec dt') ? item.width + 30 : item.width;
                item.isShowFilterControls = true;
            } else {
                if (item.key !== 'yq' && item.key !== 'yr' && item.key !== 'amt' && item.key !== 'sur' && item.key !== 'tax' && item.key !== 'ttl')
                    item.width = calculateWidth(item.stringLength ? item.stringLength > item.key.length ? item.stringLength : item.key.length : item.key.length)
                else
                    item.width = calculateWidth(item.stringLength ? item.stringLength < 8 ? 7 : item.stringLength : item.key.length)
                item.isShowFilterControls = false;
            }

            return item;
        });
        bindingTableTitle(update);
        setTableHeaderData(update);

    }
    const handleOutSideClick = () => {
        if (popUpOpenCloseConfig.rowDetails) {
            const update = tableHeaderData.map(item => {
                if (item.key === popUpOpenCloseConfig.rowDetails.dataKey) {
                    item.isShowFilterControls = false;
                }
                if (item.key !== 'yq' && item.key !== 'yr' && item.key !== 'amt' && item.key !== 'sur' && item.key !== 'tax' && item.key !== 'ttl')
                    item.width = calculateWidth(item.stringLength ? item.stringLength > item.key.length ? item.stringLength : item.key.length : item.key.length)
                else
                    item.width = calculateWidth(item.stringLength ? item.stringLength < 8 ? 7 : item.stringLength : item.key.length)
                item.isShowFilterControls = false;
                item.isFilterOpen = false;
                return item;
            });
            bindingTableTitle(update);
            setTableHeaderData(update);
            setPopUpOpenCloseConfig({
                ...popUpOpenCloseConfig,
                rowDetails: {}
            });
        }
    }
    const handleUniqueItem = (subItem, record) => {
        const updatedRecord = tableHeaderData.map((item) => {
            if (item.key === record.key) {
                item.filterUniqueValues.map((subList) => {
                    if (subList.key === subItem.key) {
                        subList.value = !subList.value
                    }
                    return subList;
                });
                const isSelectAll = item.filterUniqueValues.every(subList => subList.value === true);
                item.isSelectAll = isSelectAll ? true : false
            }
            return item;
        });
        setTableHeaderData(updatedRecord)
    }
    const handleSelectAllClick = (isSelectAll, record) => {
        const updatedRecord = tableHeaderData.map((item) => {
            if (item.key === record.key) {
                item.isSelectAll = !isSelectAll;
                item.filterUniqueValues.map((subList) => {
                    subList.value = !isSelectAll
                });
            }
            return item;
        });
        setTableHeaderData(updatedRecord)
    };
    const renderFilter = (key) => {
        const filterValue = tableHeaderData.filter(item => item.key === key)[0];
        return <div className={` ${(filterValue.isShowFilterControls) ? 'table-display-inherit' : 'table-display-none'} filter`}>
            {<div>
                <Icon name='arrow-triangle-up'
                    className={` ${(filterValue.isDefault || filterValue.isDecending) ? 'table-display-inherit' : 'table-display-none'} filter`}
                    size='md'
                    style='fill'
                    onClick={() => handleSorting(filterValue)}
                    label='Show Stored Criteria' />
                <Icon name='arrow-triangle-down'
                    className={` ${filterValue.isAscending ? 'table-display-inherit' : 'table-display-none'} filter`}
                    size='md'
                    style='fill'
                    onClick={() => handleSorting(filterValue)}
                    label='Show Stored Criteria' />
            </div>
            }
            <Popover
                isOpen={filterValue.isFilterOpen}
                positions={['bottom']}
                containerClassName={` ${isMultiFilter ? 'pop-bg-multi' : 'pop-bg'}`}
                onClickOutside={() => handleOutSideClick()}
                content={
                    <div className='full-height'
                    //  onMouseEnter={() => handleShowFilter(filterValue)}
                    //   onMouseLeave={() => handleHideFilter(filterValue)}
                    >
                        {/* <input type='text' placeholder={`Search ${item.key}`} value={item.filterValue} onChange={(event) => handleFilterChange(event.target.value, item, rowData)} /> */}
                        <TextInput
                            className='spark-pad-l-.5'
                            name={`Search ${key}`}
                            placeholder={`Search ${key}`}
                            value={filterValue.filterValue}
                            onChange={(event, selectedValue) => handleFilterChange(selectedValue, filterValue, rowData)}
                        />
                        {
                            isMultiFilter && filterValue.filterUniqueValues.length > 0 && <div> <div className='full-height-button'>
                                <div className='row'>
                                    <div>
                                        <Checkbox
                                            className='spark-bold spark-align-items-center'
                                            label='Select All'
                                            checked={filterValue.isSelectAll}
                                            onChange={() => handleSelectAllClick(filterValue.isSelectAll, filterValue)} />
                                    </div>
                                </div>
                                <div className={` ${filterValue.filterUniqueValues.length > 4 ? 'popup-checkbox-content' : 'popup-checkbox-min-content'} table-view-auto-x-scroll`}>
                                    {
                                        filterValue.filterUniqueValues.map((subItem, index) => {
                                            return <Checkbox
                                                key={index}
                                                className='spark-bold spark-align-items-center'
                                                label={subItem.key}
                                                checked={subItem.value}
                                                onChange={() => handleUniqueItem(subItem, filterValue)} />
                                        })
                                    }
                                </div>
                            </div>

                                <div className='row popup-up-controls'>
                                    <Button
                                        className='spark-btn-group-secondary select-button-cancel popup-up-controls-ok-button'
                                        size='xs'
                                        primary='true'
                                        disabled={filterValue.filterUniqueValues.every(item => !item.value)}
                                        onClick={() => handleFilterUniqueItems(filterValue, isScroll, 'Apply')}
                                    >
                                        Apply
                                    </Button>
                                    <Button
                                        className='spark-btn-group-primary'
                                        size='xs'
                                        secondary='true'
                                        onClick={() => handleClearEvent(filterValue, headerData, isScroll, true)}
                                    >
                                        Clear
                                    </Button>
                                </div>
                            </div>
                        }
                    </div>
                }
            >
                {
                    <button
                        icon={` ${!filterValue.isFilterApply ? 'menu-hamburger' : 'pencil'}`}
                        onClick={() => handleShowFilter(filterValue)}
                        className={`spark-btn--icon spark-icon spark-icon--fill spark-icon--md ${!filterValue.isFilterApply ? 'spark-icon-menu-hamburger' : 'spark-icon-pencil edit-icon spark-pad-l-.5'} filter-icon`}
                    />

                }
            </Popover>
        </div>
    }
    const headerRenderer = (header) => {
        return (<div className='spark-flex align-center spark-pad-l.5' onMouseEnter={() => handleMouseOver(header)}
            onMouseLeave={() => handleMouseLeave(header)}
        >
            <Tooltip
                anchorY='top'
                anchorX='center'
                toggleEl={<div className=' header-cell cell spark-pad-l-.5 header-cell-padding'>{header.label}</div>}
            ><div className='spark-flex'>
                    <div>{CRITERIA_HEADER_DETAILS.filter(item => item.KEY === header.label)[0].VALUE}</div>
                </div>
            </Tooltip>
            <div className='spark-flex'>
                {renderFilter(header.dataKey)}
            </div>
        </div>
        )
    }

    return (
        <div className={`table-view-root  ${isScroll ? 'table-view-auto-x-scroll' : ''} `}>
            <div className={`table-view-root ${isScroll ? 'table-component table-view-auto-x-scroll' : ''} ${!isLeftSideLayoutOpen ? 'parent-table-component-height' : 'parent-table-component-height'}`}>
                <div className={`${titleConfig.length > 1 ? 'spark-flex' : 'table-component'}`}>
                    <div className={`${titleConfig.length > 1 ? 'spark-flex' : 'table-component'}`}>
                        {
                            titleConfig.map((list, index) => <div className={`spark-pad-l-.5 spark-bold ${titleConfig.length === 1 ? 'table-full-width-important table-title-odd ' : 'table-title-odd'}`} style={{ width: list.width - 1 }}>{list.titleName}</div>)
                        }
                    </div>
                </div>
                <Table ref={reference}
                    className='table-background'
                    width={tableWidth}
                    height={isScroll ? tableHeight - 43.6 : tableHeight - 43.5}
                    headerHeight={25}
                    onScroll={handleScrolling}
                    rowHeight={20}
                    headerClassName={'table-title'}
                    noRowsRenderer={() => <div className='spark-flex spark-align-items-center no-record-text spark-bold'>No Record Found</div>}
                    rowStyle={handleRowStyle}
                    rowCount={rowData.length}
                    onColumnClick={handleColumnClick}
                    rowGetter={({ index }) => rowData[index]}>
                    {
                        tableHeaderData.map((item) => {
                            return <Column className='cell' headerRenderer={headerRenderer} cellRenderer={cellRenderer} width={item.width} label={item.key} dataKey={item.key} />
                        })
                    }
                </Table>
                {(!isScroll && totalItem) ? <div className='spark-bold spark-flex justify-space-between'>{selectedRecordConfig.selectedRowIndex && selectedRecordConfig.selectedRowIndex.length > 0 ? selectedRecordConfig.selectedRowIndex.length > 1 && selectedRecordConfig.selectedRowIndex.length : 0} {selectedRecordConfig.selectedRowIndex.length > 1 ? 'r' : 'R'}ecord{selectedRecordConfig.selectedRowIndex.length > 1 && 's'} {selectedRecordConfig.selectedRowIndex.length === 1 && `${selectedRecordConfig.currentRow + 1}`} selected (Total {rowData.length}) <div>
                    {
                        isStopAPI ? <div>
                            <Icon name='close-circle'
                                className={`spark-danger`}
                                size='md'
                                style='fill'
                                label='API stoped' />
                        </div> :
                            !isFetchDataCompleted && <div className='loader' title='Data loading...'></div>
                    }
                </div></div> : ''}
            </div>
        </div>
    )
};
TableView.propTypes = {
    rowData: array,
    reference: any,
    isScroll: bool,
    totalItem: string,
    isLeftSideLayoutOpen: bool,
    isToolTipShow: bool,
    isMultiFilter: bool,
    selectedRowDetails: object,
    selectedCellIndexValue: string,
    handleScrolling: func,
    getSelectedIndex: func,
    getSelectedCellIndex: func,
    headerData: array,
    handleSorting: func,
    handleFilterChange: func,
    handleFilterUniqueItems: func,
    handleClearEvent: func,
    fullData: array,
    isStopAPI: bool,
    hostCarrier: string,
    title: array,
    isFetchDataCompleted: bool
};
export default TableView;